import {Component} from 'react';
import h from 'react-hyperscript';
import './Form.scss';
import {p, subhead} from 'Components/Typography/Typography';

class PrefilledInput extends Component {
  render() {
    if (this.props.id === 'name') {
      return (
        h('div', {
          className: 'form-group form-group--prefilled-input',
        }, [
          h('div', {
            className: 'flex',
          }, [
            h(subhead, {
              className: 'padding-right--micro',
            }, this.props.label),
            h(p, {
              className: 'text--grey text--small padding-right--micro-2',
            }, `Not you?`),
            h('span', {
              className: 'cta--inline text--grey',
              onClick: (e) => {
                this.props.logoutClick();
              },
            }, 'Switch users'),
          ]),

          h(p, {
            className: 'text--grey',
          }, this.props.defaultValue),
        ])
      );
    } else {
      return (
        h('div', {
          className: 'form-group form-group--prefilled-input',
        }, [
          h(subhead, {
            className: 'form-group--subhead',
          }, this.props.label),
          h(p, {
            className: 'text--grey',
          }, this.props.defaultValue),
        ])
      );
    }
  }
}

export default PrefilledInput;
